import DeviceContainer from './containers/DeviceContainer'

// Sync route definition
export default {
  path      : '/device/:device_string',
  component : DeviceContainer
}



// WEBPACK FOOTER //
// ./src/routes/Device/index.js